import React from "react";
import { Tooltip, Button } from "antd";
import { FolderOpenFilled, CheckCircleFilled, ClockCircleFilled } from "@ant-design/icons";

const statusLabels = ["Definido", "Diseñado", "Implementado", "Validado", "Documentado"];

const statusMapping = {
  definido: "definited",
  diseñado: "designed",
  implementado: "implemented",
  validado: "validated",
  documentado: "documented"
};

const Columns = (handleOpenChangeLog, filters) => [
  {
    title: "Activo",
    dataIndex: "asset",
    key: "asset",
    sorter: (a, b) =>
      (a?.dependency_control?.dependency?.asset?.name || "")
        .localeCompare(b?.dependency_control?.dependency?.asset?.name || ""),

    onHeaderCell: () => ({
      style: { backgroundColor: "#FDE2E2", color: "#B22222", fontWeight: "bold" }
    }),
    showSorterTooltip: false,
    defaultFilteredValue: filters.dashboardAssetsFilter,
    filters: filters.assetFilterOptions?.map(asset => ({
      text: asset,
      value: asset
    })),
    onFilter: (value, record) =>
      record?.dependency_control?.dependency?.asset?.name === value,
    render: (_, record) =>
      record?.dependency_control?.dependency?.asset?.name || "-",
    width: "9%"
  },
  {
    title: "Control",
    dataIndex: ["dependency_control", "control", "title"],
    key: "control",
    sorter: (a, b) =>
    (a.dependency_control?.control?.title || "")
      .localeCompare(b.dependency_control?.control?.title || ""),
    onHeaderCell: () => ({
      style: { backgroundColor: "#FDE2E2", color: "#B22222", fontWeight: "bold" }
    }),
    width: "15%",
    render: (_, record) => (
      <Tooltip title={record.dependency_control?.control?.description || "Sin descripción"}>
        <span>{record.dependency_control?.control?.title || "N/A"}</span>
      </Tooltip>
    )
  },
  {
    title: "Responsable",
    dataIndex: "area",
    key: "area",
    sorter: (a, b) => (a.area?.name || "").localeCompare(b.area?.name || ""),
    defaultFilteredValue: filters.dashboardAreasFilter,
    filters: filters.areaFilterOptions?.map(area => ({
      text: area.name,
      value: area.name
    })),
    onFilter: (value, record) => record.area?.name === value,
    render: (_, record) => {
      const name = record.area?.name || "N/A";
      return name.length > 24 ? (
        <Tooltip title={name}>{name.slice(0, 24)}...</Tooltip>
      ) : (
        name
      );
    },
    onHeaderCell: () => ({
      style: { backgroundColor: "#FDE2E2", color: "#B22222", fontWeight: "bold" }
    }),
    width: "12%",
  },
  {
    title: "Estado",
    dataIndex: "initialStatus",
    key: "initialStatus",
    width: "5%",
    align: "center",
    render: (status) => (
      <span>
        {status === "Evaluado" ? (
          <CheckCircleFilled style={{ color: "#28A745", fontSize: 18 }} />
        ) : (
          <ClockCircleFilled style={{ color: "#FFA500", fontSize: 18 }} />
        )}{" "}
        {status}
      </span>
    ),
    onHeaderCell: () => ({
      style: { backgroundColor: "#FDE2E2", color: "#B22222", fontWeight: "bold" }
    }),
  },

  // ---------------------------
  // ETAPAS (solo lectura)
  // ---------------------------
  ...statusLabels.map((label) => {
    const lower = label.toLowerCase();
    const key = statusMapping[lower];

    const shouldApplyFilter =
      filters.dashboardStageFilter?.toLowerCase() === lower;

    return {
      title: label,
      key,
      dataIndex: key,
      width: "8%",
      align: "center",
      onHeaderCell: () => ({
        style: { backgroundColor: "#FDE2E2", color: "#B22222", fontWeight: "bold" }
      }),

      // ✔️ mismos filtros que tabla original
      filters: [
        { text: "Sí", value: true },
        { text: "No", value: false },
      ],

      // ✔️ soporte de filtro "etapa" desde dashboard
      filteredValue: shouldApplyFilter ? [true] : undefined,

      onFilter: (value, record) => {
        if (shouldApplyFilter) {
          return record[key] === true;
        }
        return record[key] === value;
      },

      render: (value) => (value ? "✔️" : "—"),
    };
  }),


  {
    title: "Log",
    key: "log",
    align: "center",
    width: "6%",
    onHeaderCell: () => ({
      style: { backgroundColor: "#FDE2E2", color: "#B22222", fontWeight: "bold" }
    }),
    render: (_, record) => (
      <Tooltip title="Ver Log">
        <Button
          type="link"
          icon={<FolderOpenFilled style={{ fontSize: 20, color: "#B22222" }} />}
          onClick={() => handleOpenChangeLog(record)}
        />
      </Tooltip>
    )
  }
];

export default Columns;
